import React, { useEffect, useState } from 'react';
import { SelectReportList } from './SelectReportList';
import { SelectReportDetail } from './SelectReportDetail';

const MODAL_VIEWS = {
  LIST: 'LIST',
  DETAIL: 'DETAIL',
};

export const SelectReport = ({
  show = true,
  onHide,
  onAdd,
  title,
  workspaceUrl,
  reportType,
  pageItemType,
  createReportLibraryItem,
  reportIcon,
  emptyListMessage,
  getReports,
  workspaceId,
}) => {
  const [activeView, setActiveView] = useState(MODAL_VIEWS.LIST);
  const [isShown, setIsShown] = useState(false);
  const [file, setFile] = useState();

  useEffect(() => setIsShown(show), [show]);

  const handleHide = () => {
    setIsShown(false);
    setActiveView(MODAL_VIEWS.LIST);
    onHide();
  };

  if (activeView === MODAL_VIEWS.LIST) {
    return (
      <SelectReportList
        title={title}
        show={isShown}
        onHide={handleHide}
        fileSelected={(selectedFile) => {
          setFile(selectedFile);
          setActiveView(MODAL_VIEWS.DETAIL);
        }}
        workspaceUrl={workspaceUrl}
        reportIcon={reportIcon}
        emptyListMessage={emptyListMessage}
        getReports={getReports}
        workspaceId={workspaceId}
        reportType={reportType}
      />
    );
  }

  if (activeView === MODAL_VIEWS.DETAIL) {
    return (
      <SelectReportDetail
        show={isShown}
        onHide={handleHide}
        file={file}
        onBack={() => setActiveView(MODAL_VIEWS.LIST)}
        onAdd={onAdd}
        title={title}
        workspaceUrl={workspaceUrl}
        reportType={reportType}
        pageItemType={pageItemType}
        createReportLibraryItem={createReportLibraryItem}
        workspaceId={workspaceId}
      />
    );
  }

  return null;
};
